import Types from '../utils/type';
import { isEqObject, isEqArray, getPropByPath, compareNumber } from '../utils';
import { multiply, add } from '../utils/math';

const getOffsetDate = (value, offset = 0, unit) => {
    let trustOffset = offset;
    if (unit === 'day') {
        trustOffset = multiply(offset, 86400000);
    }
    if (unit === 'week') {
        trustOffset = multiply(offset, 604800000);
    }
    return add(+value, +trustOffset);
};

const requiredValidFun = (rule, value, source, options, config) => {
    config.message = `${options.validLabel || ''}必填`;
    // 自定义必填校验，原生校验数组不支持
    if (Types.empty(value)) return false;
    // 数组必填校验
    if (config.validArray && Types.array(value) && value.length === 0) return false;
    return true;
};

const typeValidFun = (rule, value, source, options, config) => {
    if (!Types[config.type]) {
        throw new TypeError('config.type类型错误');
    }
    if (!Types[config.type](value)) return false;
    return true;
};

const notValidFun = (rule, value, source, options, config) => {
    let trustValue = value;
    const base = rule.getBase(config, source, options);
    if (config.stringToNumber) {
        trustValue = +value;
    }
    if (trustValue === base) return false;
    if (config.deep) {
        if (Types.object(trustValue) && Types.object(base) && isEqObject(trustValue, base)) {
            return false;
        }
        if (Types.array(trustValue) && Types.array(base) && isEqArray(trustValue, base)) {
            return false;
        }
    }
    return true;
};

const rangeValidFun = (rule, value, source, options, config) => {
    if (!Types.number(config.min) || !Types.number(config.max)) {
        throw new TypeError('错误的参数类型');
    }
    if (!Types.number(value)) return false;
    const v = +value;
    if (v < config.min || v > config.max || (!config.le && config.min === v) || (!config.ge && config.max === v)) return false;
    return true;
};

const lenRangeValidFun = (rule, value, source, options, config) => {
    if (!Types.number(config.min) || !Types.number(config.max)) {
        throw new TypeError('错误的参数类型');
    }
    const len = value.length;
    if (len < config.min || len > config.max) return false;
    return true;
};

const intLenValidFun = (rule, value, source, options, config) => {
    const { len, isEqual } = config;
    if (!Types.number(value)) return false;
    const temp = `${value}`.split('.')[0];
    const { length } = temp;
    if (length > len || (isEqual && length !== len)) return false;
    return true;
};

const decimalValidFun = (rule, value, source, options, config) => {
    const { len, isEqual } = config;
    if (!Types.number(value)) return false;
    const temp = `${value}`.split('.')[1];
    const length = (temp && temp.length) || 0;
    if (length > len || (isEqual && length !== len)) return false;
    return true;
};

const patternValidFun = (rule, value, source, options, config) => {
    if (!config.reg.test(value)) {
        return false;
    }
    return true;
};

const multipleValidFun = (rule, value, source, options, config) => {
    const base = rule.getBase(config, source, options);
    let valueStr = `${value}`;
    let baseStr = `${base}`;
    const valueSplit = valueStr.split('.');
    const baseSplit = baseStr.split('.');
    const valueDecimalLength = (valueSplit[1] || '').length;
    const baseDecimalLength = (baseSplit[1] || '').length;
    valueStr = `${valueSplit[0]}${(valueSplit[1] || '').padEnd(Math.max(valueDecimalLength, baseDecimalLength), '0')}`;
    baseStr = `${baseSplit[0]}${(baseSplit[1] || '').padEnd(Math.max(valueDecimalLength, baseDecimalLength), '0')}`;
    if (+valueStr % +baseStr !== 0) return false;
    return true;
};

const inListValidFun = (rule, value, source, options, config) => {
    const { list } = config;
    if (!list || !Types.array(list)) {
        return true;
    }
    if (!list.includes(value)) {
        return false;
    }
    return true;
};

const uniqArrayValidFun = (rule, value, source, options, config) => {
    if (!Types.array(value)) return false;
    let arr = value;
    if (config.callback && Types.method(config.callback)) {
        arr = config.callback(value, source, options.extraData);
    } else if (config.key) {
        arr = value.map(item => {
            return getPropByPath(item, config.key).v;
        });
    }
    if (new Set(arr).size !== arr.length) return false;
    return true;
};

const arrayTypeValidFun = (rule, value, source, options, config) => {
    if (!Types.array(value)) return false;
    if (!Types.array(config.types)) {
        throw new TypeError('类型错误：config.types应该为数组类型');
    }
    if (value.every((item, index) => Types[config.types[index]](item))) {
        return true;
    }
    return false;
};

const vmVliadFun = (rule, value, source, options, config) => {
    const method = config.method || 'validate';
    const vm = config.vm || options.vm;
    if (!vm) return true;
    return vm[method]();
};

const compareValidFun = (rule, value, source, options, config) => {
    let base = rule.getBase(config, source, options);
    base = add(+base, config.offset || 0);
    return compareNumber(value, base, config.flag);
};

const compareTimeValidFun = (rule, value, source, options, config) => {
    let base = rule.getBase(config, source, options);
    if (typeof value === 'string' && isNaN(value)) {
        const { format = 'yyyy-MM-dd HH:mm:ss' } = config;
        const transferValue = {};
        const transferBase = {};
        const date = new Date();
        // const reg = format.replace(/y{4}/g, '\\d{4}').replace(/[MdHms]{2}/g, '\\d{2}');
        const keyList = [
            { key: 'y', value: date.getFullYear() },
            { key: 'M', value: date.getMonth() + 1 },
            { key: 'd', value: date.getDate() },
            { key: 'H', value: date.getHours() },
            { key: 'm', value: date.getMinutes() },
            { key: 's', value: date.getSeconds() }
        ];
        const valueSplited = value.split('');
        const baseSplited = base.split('');
        format.split('').forEach((key, index) => {
            transferValue[key] = `${transferValue[key] || ''}${valueSplited[index]}`;
            transferBase[key] = `${transferBase[key] || ''}${baseSplited[index]}`;
        });
        const valueArr = [];
        const baseArr = [];
        keyList.forEach(item => {
            valueArr.push(transferValue[item.key] || item.value);
            baseArr.push(transferBase[item.key] || item.value);
        });
        try {
            value = new Date(...valueArr);
            base = new Date(...baseArr);
        } catch (e) {
            throw new Error('数据格式与规则配置不符');
        }
    }
    base = new Date(getOffsetDate(base, config.offset, config.unit));
    return compareNumber(value, base, config.flag);
};

const notOverlap = (rule, value, source, options, config) => {
    const { cantUnion } = config;
    if (!Types.array(value)) {
        throw new TypeError('类型错误: value应该是数组');
    }
    const begin = value.map(i => i[0]).sort((a, b) => a - b);
    const over = value.map(i => i[1]).sort((a, b) => a - b);
    return value.every((_, i) => {
        if (i === 0) {
            return true;
        }
        if (cantUnion) {
            return +begin[i] > +over[i - 1];
        }
        return +begin[i] >= +over[i - 1];
    });
};

export default {
    requiredValidFun,
    typeValidFun,
    notValidFun,
    rangeValidFun,
    lenRangeValidFun,
    intLenValidFun,
    decimalValidFun,
    patternValidFun,
    multipleValidFun,
    inListValidFun,
    uniqArrayValidFun,
    arrayTypeValidFun,
    vmVliadFun,
    compareValidFun,
    compareTimeValidFun,
    notOverlap
};
